import React from 'react'
import Content from '../components/Content';
import Gallery from '../components/Gallery';
import Navbar from './../components/Navbar';
import Footer from './../components/Footer/Footer';

const About = () => {
  return (
    <>
      <Navbar/>
      <Content />
      <Gallery />
      <Footer/>
    </>
  )
}

export default About